<div class="mt-4">
  <div class="w-full py-4 text-center">
    <button [routerLink]="'/profile/me'">
      <app-user-icon color="blue" size="large" />
    </button>
  </div>

  <!-- Sound toggle -->
  <!--  <div class="mt-8 mx-1 xl:mx-6 flex justify-center">-->
  <!--    <mat-slide-toggle-->
  <!--      color="primary"-->
  <!--      labelPosition="before"-->
  <!--      [checked]="voiceService.audioEnabled()"-->
  <!--      (change)="voiceService.audioEnabled.set(!voiceService.audioEnabled())"-->
  <!--      class="m-auto"-->
  <!--      ><span class="text-white text-center font-bold"-->
  <!--        >Mit Ton</span-->
  <!--      ></mat-slide-toggle-->
  <!--    >-->
  <!--  </div>-->

  <!-- User menu items -->
  <div class="mt-4">
    <button [routerLink]="'/profile/me'" class="menu-item" data-testid="menu-item-profile">
      <i class="pi pi-user mr-4 !text-lg !text-zinc-800"></i>
      {{ 'user.menu.profile' | transloco }}
    </button>

    <app-trigger-release-notes [updatesAvailable]="versionService.versionIsBrandNew() || versionService.updateAvailable()" buttonClass="menu-item" />

    @if (isAdmin()) {
      <button
        [routerLink]="'/devices'"
        class="menu-item !text-zinc-800"
        [ngClass]="{ 'opacity-50': subscriptionExpired() }"
        [disabled]="subscriptionExpired()"
        data-testid="menu-item-devices">
        <i class="pi pi-file-edit mr-4 !text-lg"></i>
        {{ 'user.menu.manageDevices' | transloco }}
      </button>
    }

    <button (click)="authService.logout()" class="menu-item" data-testid="user-logout-button">
      <i class="pi pi-power-off mr-4 !text-lg !text-zinc-800"></i>
      @if (isAdmin()) {
        {{ 'user.menu.logout' | transloco }}
      } @else {
        {{ 'user.menu.logoutDevice' | transloco }}
      }
    </button>
  </div>

  <div class="flex justify-between gap-4 pl-5 pr-9 pt-8">
    <!-- Cookie consent -->
    @if (gtmIsEnabled()) {
      <a href="?cmpscreen" class="cmpfooterlink cmpfooterlinkcmp text-xs text-stone-500 subpixel-antialiased hover:text-black">
        {{ 'user.menu.cookieSettings' | transloco }}
      </a>
    }
  </div>

  <!-- Legal Pages -->
  <div class="flex justify-between gap-4 pb-5 pl-5 pr-9 pt-4">
    <a href="https://qira.net/imprint" target="_blank" class="text-xs text-stone-500 subpixel-antialiased hover:text-black">
      {{ 'legal.imprint' | transloco }}
    </a>
    <a href="https://qira.net/privacy" target="_blank" class="text-xs text-stone-500 subpixel-antialiased hover:text-black">
      {{ 'legal.privacy' | transloco }}
    </a>
    <a href="https://qira.net/terms" target="_blank" class="text-xs text-stone-500 subpixel-antialiased hover:text-black">
      {{ 'legal.tac' | transloco }}
    </a>
  </div>
</div>
